<template>
  <el-aside class="admin-aside global-aside" width="250px">
    <div class="aside-container" v-show="!adminBrand._id">
      <div class="aside-title">
        <span>Global</span>
      </div>
      <div class="aside-group">
        <div class="group-title">
          <span>BRANDS</span>
        </div>
        <div class="group-list">
          <div
            :class="['group-item', currentTab == 'brands' ? 'active' : '']"
            @click="redirectTo('/global/brands')"
          >
            <span>Manage</span>
          </div>
          <div
            :class="['group-item', currentTab == 'invitations' ? 'active' : '']"
            @click="redirectTo('/global/invitations')"
          >
            <span>Onboard</span>
          </div>
        </div>
      </div>
      <div class="aside-group">
        <div class="group-title">
          <span>PRODUCTS</span>
        </div>
        <div class="group-list">
          <div
            :class="['group-item', currentTab == 'products' ? 'active' : '']"
            @click="redirectTo('/global/products')"
          >
            <span>Manage</span>
          </div>
          <div
            :class="['group-item', currentTab == 'categories' ? 'active' : '']"
            @click="redirectTo('/global/categories')"
          >
            <span>Categories</span>
          </div>
        </div>
      </div>
      <div class="aside-group">
        <div class="group-title">
          <span>AUDIOS</span>
        </div>
        <div class="group-list">
          <div
            :class="['group-item', currentTab == 'audios' ? 'active' : '']"
            @click="redirectTo('/global/audios')"
          >
            <span>Manage</span>
          </div>
        </div>
      </div>
      <div class="aside-group">
        <div class="group-title">
          <span>ATK PLAYER</span>
        </div>
        <div class="group-list">
          <div
            :class="['group-item', currentTab == 'infos' ? 'active' : '']"
            @click="redirectTo('/global/infos')"
          >
            <span>Info Pages</span>
          </div>
          <div
            :class="['group-item', currentTab == 'guides' ? 'active' : '']"
            @click="redirectTo('/global/guides')"
          >
            <span>Client Guides</span>
          </div>
          <div
            :class="['group-item', currentTab == 'landing' ? 'active' : '']"
            @click="redirectTo('/global/landing')"
          >
            <span>Landing Page</span>
          </div>
        </div>
      </div>
      <div class="aside-group">
        <div class="group-title">
          <span>Statistics</span>
        </div>
        <div class="group-list">
          <div
            :class="['group-item', currentTab == 'statistics_brands' ? 'active' : '']"
            @click="redirectTo('/global/statistics/brands')"
          >
            <span>Brands</span>
          </div>
          <div
            :class="['group-item', currentTab == 'statistics_atk' ? 'active' : '']"
            @click="redirectTo('/global/statistics/atk')"
          >
            <span>ATK</span>
          </div>
        </div>
      </div>
      <div class="aside-group">
        <div class="group-title">
          <span>CUSTOMERS</span>
        </div>
        <div class="group-list">
          <div
            :class="['group-item', currentTab == 'customers' ? 'active' : '']"
            @click="redirectTo('/global/customers')"
          >
            <span>Manage</span>
          </div>
        </div>
      </div>
      <div class="aside-group">
        <div class="group-title">
          <span>PLANS</span>
        </div>
        <div class="group-list">
          <div
            :class="['group-item', currentTab == 'plans' ? 'active' : '']"
            @click="redirectTo('/global/plans')"
          >
            <span>Manage</span>
          </div>
        </div>
      </div>
    </div>
    <div class="aside-container" v-show="adminBrand._id">
      <div class="aside-action" @click="redirectTo('/global/brands')">
        <el-icon :size="20"><back /></el-icon>
        <span>Global Admin</span>
      </div>
      <div class="aside-manage">
        <span>Managing: </span>
        <span>{{ adminBrand.name }}</span>
      </div>
      <div class="aside-group">
        <div class="group-title">
          <span>CONTENT</span>
        </div>
        <div class="group-list">
          <div
            :class="['group-item', currentTab == 'brand_products' ? 'active' : '']"
            @click="redirectTo(`/global/brands/${adminBrand._id}/products`)"
          >
            <span>Products</span>
          </div>
        </div>
      </div>
      <div class="aside-group">
        <div class="group-title">
          <span>INTEGRATION</span>
        </div>
        <div class="group-list">
          <div
            :class="['group-item', currentTab == 'brand_instances' ? 'active' : '']"
            @click="redirectTo(`/global/brands/${adminBrand._id}/instances`)"
          >
            <span>My Players</span>
          </div>
        </div>
      </div>
    </div>
  </el-aside>
</template>

<script>
import { mapGetters } from 'vuex'
import { Back } from '@element-plus/icons'
export default {
  name: 'GlobalSidebar',
  props: {
  },
  components: {
    Back
  },
  data: function () {
    return {
    }
  },
  methods: {
    redirectTo: function (url) {
      this.$router.push(url)
    }
  },
  computed: {
    ...mapGetters({
      currentTab: 'currentTab',
      adminBrand: 'adminBrand'
    })
  }
}
</script>

<style scoped lang="scss">
.global-aside {
  border-right: solid 1px #F2F2F2;
}
</style>
